export default "__VITE_ASSET__D3ojWd1F__"